// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import { ToastContainer } from 'react-toastify'
import { IntlProviderWrapper } from './utility/context/Internationalization'
import { ThemeContext } from './utility/context/ThemeColors'

// ** CUSTOM CSS/JS INDEX.HTML
import './assets/custom/bootstrap.min.css'
import './assets/custom/font-awesome/font-awesome.min.css'
import './assets/custom/fonts/fonts_googleapis_com_css_family_montserrat_ital.css'
import './assets/custom/leaflet/leaflet.css'
import './assets/custom/npm_sweetalert'
import './assets/custom/tinymce.min'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** Fake Database
import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/components/prism-jsx.min'
import 'prismjs/themes/prism-tomorrow.css'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      {/* <AbilityContext.Provider value={ability}> */}
      <ThemeContext>
        <IntlProviderWrapper>
          <LazyApp />
          <ToastContainer newestOnTop />
        </IntlProviderWrapper>
      </ThemeContext>
      {/* </AbilityContext.Provider> */}
    </Suspense>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
